import React, {PureComponent} from 'react';
import $ from "jquery";
import {formatTime, calculateAVGSpeed} from '../functions/utils';
import ReactTooltip from 'react-tooltip';
import Alert from 'react-s-alert';
import {
    subscribeToLapInfo,
    subscribeCarToServer,
    subscribeDashToServer,
    connectSocket,
    confirmIdentity,
    closeSocket
} from "../functions/api";

import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";

import Moment from "moment-timezone";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

class PopoutMiniChallengeZones extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            sectors: [],
            laps: [],
            tableRows: [],
            maxes: {
                personal: {min_time: 0, max_speed_obd: 0, max_speed_gps: 0, max_g_x: 0, min_g_x: 0, max_g_y: 0, min_g_y: 0, max_accel_time: 0,},
                overall: {min_time: 0, max_speed_obd: 0, max_speed_gps: 0, max_g_x: 0, min_g_x: 0, max_g_y: 0, min_g_y: 0, max_accel_time: 0,}
            },
            trackLength: 0,
            overallBestColor: "#980092",
            personalBestColor: "#019c00",
            selectedLaps: [],
            numSpeedTraps: 0,
            carList: [],
            carID: parseInt(this.props.match.params.carID),
            currentLiveryID: "---",
            confirmedOrg: true,
        };

        this.getSessionDetails = this.getSessionDetails.bind(this);
        this.getCarLaps = this.getCarLaps.bind(this);
        this.popoutDetail = this.popoutDetail.bind(this);
        this.getCircuitDetails = this.getCircuitDetails.bind(this);
        this.getMaxes = this.getMaxes.bind(this);
        this.makeTableRows = this.makeTableRows.bind(this);
        this.getCarList = this.getCarList.bind(this);
        this.handleChangeCar = this.handleChangeCar.bind(this);
    }

    componentDidMount() {
        confirmIdentity(this.props.cookies.get("authToken"), this.props.match.params.userID, this.props.match.params.eventID, (confirmed) => {
            if (confirmed) {
                // Connect Socket
                connectSocket(this.props.cookies.get("authToken"), this.props.match.params.carID, this.props.match.params.sessionID, this.props.match.params.eventID, "MINICHALLENGEZONES", (msg) => {
                    console.log("[MINI ZONES]" + msg);
                    subscribeDashToServer(this.props.match.params.eventID, this.props.match.params.sessionID, () => {
                        console.log("[MINI CHALLENGE] DEDICATED STREAM SUBSCRIBED");
                    });
                    // Notify server of new connection
                    subscribeCarToServer(this.props.match.params.eventID, this.props.match.params.carID, () => {

                    });
                    // Connect to Laps Info feed
                    subscribeToLapInfo(this.state.carID, this.props.match.params.carID, false, () => {
                        this.getSessionDetails();
                    });
                });
                this.getCarList();
                // Start chained actions
                this.getSessionDetails();
            } else {
                this.setState({
                    confirmedOrg: false,
                });
            }
        });
    }

    componentWillUnmount() {
        // DS
        subscribeDashToServer(this.props.match.params.eventID, this.props.match.params.sessionID, () => {
            console.log("[MINI CHALLENGE] DEDICATED STREAM UNSUBSCRIBED");
        });
        // Notify server of new connection
        subscribeCarToServer(this.props.match.params.eventID, null, () => {
            console.log("[MINI CHALLENGE] DEDICATED CAR STREAM UNSUBSCRIBED");
        });
        subscribeToLapInfo(this.props.match.params.carID, null, true, null);
        closeSocket();
    }

    getSessionDetails() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getSessionDetails',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                helper.setState({
                    trackLength: data.track_length,
                    timezone: data.timezone,
                    numSpeedTraps: data.speed_control_zone_cnt,
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
            }
        }).done(function () {
            console.log("[MINI CHALLENGE] COMPLETE getSessionDetails");
            helper.getCircuitDetails();
        });
    }

    getCircuitDetails() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getSectorInfo',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                eventID: helper.props.match.params.sessionID
            },
            success: function (data) {
                helper.setState({
                    sectors: data,
                });
            },
            error: function (err) {
                if (err) {
                    console.error('[MINI CHALLENGE] getCircuitDetails Error:', err);
                }
                return false;
            }
        }).done(function () {
            console.log("[MINI CHALLENGE] COMPLETE getCircuitDetails");
            helper.getMaxes();
        });
    }

    getCarList() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getCarList',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
                teamID: helper.props.match.params.teamID,
                carIDs: null,
            },
            success: function (data) {
                helper.setState({
                    carList: data,
                }, () => {
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].id === parseInt(helper.props.match.params.carID)) {
                            helper.setState({
                                currentLiveryID: data[i].livery_number,
                            });
                            break;
                        }
                    }
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                helper.setState({
                    carList: [{
                        id: 0,
                        livery_number: 0,
                        short_name: "---",
                        title: "---",
                        speedSource: "OBD",
                    }]
                });
            }
        });
    }

    getMaxes() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getMaxes',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
                carID: helper.props.match.params.carID,
            },
            success: function (data) {
                if (data && data.length > 0) {
                    helper.setState({
                        maxes: data[0],
                    });
                }
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                return false;
            }
        }).done(function () {
            console.log("[MINI CHALLENGE] COMPLETE getMaxes");
            helper.getCarLaps();
        });
    }

    getCarLaps() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getLapsByCarIdMiniChallenge',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
                carID: helper.state.carID,
            },
            success: function (data) {
                helper.setState({
                    laps: data,
                }, () => {
                    helper.makeTableRows();
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                $('.loading').fadeOut();
                return false;
            }
        });
    }

    popoutDetail(e) {
        e.preventDefault();
        window.open(
            "/lapDetails/" + this.props.match.params.eventID + "/" + this.props.match.params.sessionID + "/" + e.target.value,
            'lapDetail',
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,left=100,top=100,height=750,width=900"
        );
    }

    makeTableRows() {
        let rows = [];
        if (this.state.laps.length > 0) {
            // For each lap the car made
            rows = this.state.laps.filter((lap) => {
                return calculateAVGSpeed(lap.time, this.state.trackLength) <= 250;
            }).map((lap) => {
                let zones = [];
                if (lap.zones.length > 1) {
                    // Iterate through known control zones
                    let found;
                    for (let speedTrap = 0; speedTrap < this.state.numSpeedTraps; speedTrap++) {
                        found = false;
                        for (let i = 0; i < lap.zones.length; i++) {
                            if (lap.zones[i].speed_control_zone_internal_order === speedTrap) {
                                found = true;
                                zones.push(
                                    <td key={i}
                                        id={"split_cell"}
                                        data-tip={true}
                                        data-for={"zone_" + i + "_" + lap.zones[i].session_lap_id}
                                        style={{
                                            backgroundColor: lap.zones[i].is_clean_transition === 1 ? "#009e1a" : "#dd0008",
                                            color: "#FFFFFF",
                                            width: "7%"
                                        }}
                                    >
                                        <div style={{cursor: "pointer"}}>
                                            {(lap.zones[i].is_clean_transition === 1 ? this.props.t("ok").toUpperCase() : this.props.t("overLimit").toUpperCase())}
                                            <ReactTooltip id={"zone_" + i + "_" + lap.zones[i].session_lap_id} type={"light"}>
                                                {(lap.zones[i].is_clean_transition === 0 ? (
                                                    <h2 style={{backgroundColor: "#d90020", color: "#FFFFFF"}}>{this.props.t("max").toUpperCase()}: {lap.zones[i].trigger_speed_if_not_clean_transition} km/h</h2>
                                                ) : (
                                                    <h2 style={{backgroundColor: "#008607", color: "#FFFFFF"}}>{this.props.t("max").toUpperCase()}: {lap.zones[i].trigger_speed_if_not_clean_transition} km/h</h2>
                                                ))}
                                                <p className={"App_header"} style={{color: "#000000"}}>
                                                    {this.props.t("entry")}: <strong style={{fontSize: 26, color: (lap.zones[i].is_clean_transition === 1 ? "#008607" : "#d90020")}}>{lap.zones[i].entry_speed}</strong> km/h
                                                </p>
                                                <p className={"App_header"} style={{color: "#000000"}}>
                                                    {this.props.t("exit")}: <strong style={{fontSize: 26, color: (lap.zones[i].is_clean_transition === 1 ? "#008607" : "#d90020")}}>{lap.zones[i].exit_speed}</strong> km/h
                                                </p>
                                                <p className={"App_header"} style={{color: "#000000"}}>
                                                    {this.props.t("avg")}: <strong style={{fontSize: 26, color: (lap.zones[i].is_clean_transition === 1 ? "#008607" : "#d90020")}}>{lap.zones[i].avg_speed}</strong> km/h
                                                </p>
                                            </ReactTooltip>
                                        </div>
                                    </td>
                                );
                                break;
                            }
                        }
                        if (!found) {
                            zones.push(<td key={speedTrap + "_not"}>---</td>);
                        }
                    }

                    return (
                        <tr key={lap.id} className={"App_white_text onHover"}>
                            <td style={{width: "2%"}}>
                                <button
                                    style={{background: "#ff0003", fontWeight: "bold"}}
                                    type={"button"}
                                    className={"btn button"}
                                    value={lap.uuid}
                                    onClick={this.popoutDetail}
                                >
                                    {lap.lap_number}
                                </button>
                            </td>
                            <td style={{borderRight: "2px solid white", margin: 0, padding: 0}}>
                                <span style={{display: "block"}}>{lap.driver_name}</span>
                                <span className={"App_timestampStyle"}>{Moment(lap.registry_timestamp).tz(this.state.timezone).format("HH:mm:ss")}</span>
                            </td>
                            <td style={{borderRight: "2px solid white", margin: 0, padding: 0}}>
                                <span style={{display: "block"}}>{formatTime(lap.time)}</span>
                                <span className={"App_lapGapStyle"} style={{color: lap.split_to_previous_lap_time < 0 ? "#00ff38" : "#ff1b00"}}>{(lap.split_to_previous_lap_time > 0 ? "+" : "") + (lap.split_to_previous_lap_time / 1000)}</span>
                            </td>
                            {zones}
                            <td className={"hidden-xs"}>{(lap.max_speed > 0 && lap.max_speed < 500) ? lap.max_speed : "---"} / {calculateAVGSpeed(lap.time, this.state.trackLength)}</td>
                        </tr>
                    );
                } else {
                    return (<tr key={lap.id}/>);
                }
            });
        }

        this.setState({
            tableRows: rows,
        }, () => {
            $(".loading").fadeOut();
        });
    }

    handleChangeCar(action) {
        switch (action) {
            case "next": {
                $('.loading').fadeIn();
                for (let i = 0; i < this.state.carList.length; i++) {
                    if (this.state.carID === this.state.carList[i].id) {
                        let index = -1;
                        if (i === this.state.carList.length - 1) {
                            index = 0;
                        } else {
                            index = i + 1;
                        }
                        this.setState({
                            carID: this.state.carList[index].id,
                            currentLiveryID: this.state.carList[index].livery_number,
                        }, () => {
                            this.getCarLaps();
                        });
                        break;
                    }
                }
                break;
            }
            case "previous": {
                $('.loading').fadeIn();
                for (let i = 0; i < this.state.carList.length; i++) {
                    if (this.state.carID === this.state.carList[i].id) {
                        let index = -1;
                        if (i === 0) {
                            index = this.state.carList.length - 1;
                        } else {
                            index = i - 1;
                        }
                        this.setState({
                            carID: this.state.carList[index].id,
                            currentLiveryID: this.state.carList[index].livery_number,
                        }, () => {
                            this.getCarLaps();
                        });
                        break;
                    }
                }
                break;
            }
            default: {
                break;
            }
        }
    }

    render() {
        if (this.state.confirmedOrg) {
            let zones = [];
            for (let i = 0; i < this.state.numSpeedTraps; i++) {
                zones.push(
                    <th key={"header_zone_" + i} className={"App_header_background hidden-xs"}>Zone {i + 1}</th>
                );
            }

            return (
                <div className={"container-fluid"} style={{marginTop: 15, marginBottom: 15}}>
                    <div className={"row"}>
                        <div className={"col-sm-12"}>
                            <div className={"App_ContainerStyle"} style={{marginBottom: 15, padding: 10}}>
                                <button
                                    data-tip={true}
                                    data-for={"previousLap"}
                                    className={"btn App_white_text button"}
                                    style={{background: "#ff0003", fontWeight: "bold"}}
                                    type="button"
                                    onClick={() => {
                                        this.handleChangeCar("previous");
                                    }}
                                >
                                    <i className={"fas fa-angle-double-left"}/>
                                </button>
                                <ReactTooltip id={"previousLap"} type={"light"}>
                                    <span className={"toolTipStyle"}>{this.props.t("previousVehicle")}</span>
                                </ReactTooltip>
                                <button
                                    data-tip={true}
                                    data-for={"nextLap"}
                                    className={"btn App_white_text button"}
                                    style={{background: "#ff0003", fontWeight: "bold", marginLeft: 10}}
                                    type={"button"}
                                    onClick={() => {
                                        this.handleChangeCar("next");
                                    }}
                                >
                                    <i className={"fas fa-angle-double-right"}/>
                                </button>
                                <ReactTooltip id={"nextLap"} type={"light"}>
                                    <span className={"toolTipStyle"}>{this.props.t("nextVehicle")}</span>
                                </ReactTooltip>
                                <span style={{
                                    color: "#FFFFFF",
                                    height: 50,
                                    fontSize: 30,
                                    margin: "10px 10px 10px 20px",
                                    border: "none",
                                    fontFamily: "Iceland",
                                    fontWeight: "bold",
                                    width: 150
                                }}>
                                Car #{this.state.currentLiveryID}
                            </span>
                            </div>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-sm-12"}>
                            <div className={"App_ContainerStyle table-scroll-parent"} style={{whiteSpace: "nowrap"}}>
                                <div className="loading">
                                    <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                                </div>
                                <div className={"table-scroll-child table-responsive"}>
                                    <Alert stack={{limit: 10}} html={true}/>
                                    <table className={"table table-condensed"} style={{textAlign: "center"}}>
                                        <thead>
                                        <tr>
                                            <th className={"App_header"}>{this.props.t("lap")}</th>
                                            <th className={"App_header"}>{this.props.t("driver")}</th>
                                            <th className={"App_header"}>{this.props.t("lapTime")}</th>
                                            {zones}
                                            <th className={"App_header hidden-xs"}>{this.props.t("maxAvgSpd")}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td colSpan={20} style={{background: "#eb1f24"}}/>
                                        </tr>
                                        {this.state.tableRows}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div/>
            );
        }
    }
}

export default withTranslation("translations")(withCookies(PopoutMiniChallengeZones));